export const redirectModal = onClose => {
  location.href = '/'
  onClose()
}
